export function isItemBlankSampleOrPrintedSample(item) {
  return isItemBlankSample(item) || isItemPrintedSample(item);
}
export function isItemBlankSample(item) {
  return !!item.isSample;
}
export function isItemPrintedSample(item) {
  return !!item.isPrintedSample;
}